import { render, staticRenderFns } from "./AddPriceTypeModal.vue?vue&type=template&id=64c91b79&lang=html"
import script from "./AddPriceTypeModal.vue?vue&type=script&lang=js"
export * from "./AddPriceTypeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports